/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {

	/**
	 * Wait untill all given conditions are met
	 * @param {Function[]} conditions
	 * @param {number} [timeout=60000]
	 * @returns {Promise}
	 */
	Vue.prototype.waitUntil = function(conditions, timeout = 60000) {
		return new Promise((resolve) => {
			let cancelStateTimeout = null;
			let readyStateInterval = null;
			const returnDone = (allConditionsMet = false) => {
				clearInterval(readyStateInterval);
				clearTimeout(cancelStateTimeout);
				resolve(allConditionsMet);
			};
			cancelStateTimeout = setTimeout(returnDone, timeout);
			readyStateInterval = setInterval(() => {
				if (conditions.every((condition) => condition())) {
					returnDone(true);
				}
			}, 50);
		});
	};

};

export default {
	install
};
